import { render } from "./callFollowUpForm.vue?vue&type=template&id=29d39de4&scoped=true"
import script from "./callFollowUpForm.vue?vue&type=script&lang=js"
export * from "./callFollowUpForm.vue?vue&type=script&lang=js"

import "./callFollowUpForm.vue?vue&type=style&index=0&id=29d39de4&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d39de4"]])

export default __exports__